import React from 'react';
import { X, Volume2, Music } from 'lucide-react';

interface SettingsModalProps {
    onClose: () => void;
    musicVolume: number;
    sfxVolume: number;
    onMusicVolumeChange: (volume: number) => void;
    onSfxVolumeChange: (volume: number) => void;
}

export function SettingsModal({
    onClose,
    musicVolume,
    sfxVolume,
    onMusicVolumeChange,
    onSfxVolumeChange,
}: SettingsModalProps) {
    return (
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center pointer-events-auto z-50">
            <div className="bg-gray-800 p-8 rounded-xl shadow-2xl text-white border-2 border-gray-700 w-full max-w-md relative">
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white">
                    <X size={28} />
                </button>
                <h2 className="text-4xl font-bold mb-8 text-center">Settings</h2>
                
                <div className="space-y-6">
                    {/* Music Volume */}
                    <div className="flex flex-col">
                        <label htmlFor="music-volume" className="flex items-center text-xl mb-2">
                            <Music className="w-6 h-6 mr-3 text-yellow-400" />
                            <span>Music Volume</span>
                        </label>
                        <div className="flex items-center gap-4">
                            <input
                                id="music-volume"
                                type="range"
                                min="0"
                                max="1"
                                step="0.01"
                                value={musicVolume}
                                onChange={(e) => onMusicVolumeChange(parseFloat(e.target.value))}
                                className="w-full"
                            />
                            <span className="font-bold w-12 text-center">{Math.round(musicVolume * 100)}%</span>
                        </div>
                    </div>

                    {/* SFX Volume */}
                    <div className="flex flex-col">
                        <label htmlFor="sfx-volume" className="flex items-center text-xl mb-2">
                            <Volume2 className="w-6 h-6 mr-3 text-yellow-400" />
                            <span>SFX Volume</span>
                        </label>
                        <div className="flex items-center gap-4">
                            <input
                                id="sfx-volume"
                                type="range"
                                min="0"
                                max="1"
                                step="0.01"
                                value={sfxVolume}
                                onChange={(e) => onSfxVolumeChange(parseFloat(e.target.value))}
                                className="w-full"
                            />
                            <span className="font-bold w-12 text-center">{Math.round(sfxVolume * 100)}%</span>
                        </div>
                    </div>
                </div>

                <div className="mt-10 text-center">
                    <button
                        onClick={onClose}
                        className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold py-2 px-8 rounded-lg text-xl transition-transform transform hover:scale-105"
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
}
